import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getBulkHistoryState = createSelector(
  getDragonflyState,
  (state) => state.bulkHistory
);

export const getPanelExpansion = createSelector(
  getBulkHistoryState,
  ({ panelExpanded }) => panelExpanded
);

export const getConfigurationName = createSelector(
  getBulkHistoryState,
  ({ configurationName }) => configurationName
);

export const getStatusValues = createSelector(
  getBulkHistoryState,
  ({ statusValues }) => statusValues
);

export const getStatus = createSelector(
  getBulkHistoryState,
  ({ status }) => status
);

export const getImportDateFrom = createSelector(
  getBulkHistoryState,
  ({ importDateFrom }) => importDateFrom
);

export const getImportDateFromFormat = createSelector(
  getBulkHistoryState,
  ({ importDateFromFormat }) => importDateFromFormat
);

export const getImportDateUntil = createSelector(
  getBulkHistoryState,
  ({ importDateUntil }) => importDateUntil
);

export const getImportDateUntilFormat = createSelector(
  getBulkHistoryState,
  ({ importDateUntilFormat }) => importDateUntilFormat
);

export const getImportDateFromValidation = createSelector(
  getBulkHistoryState,
  ({ importDateFrom }) =>
    importDateFrom?.toISOString() !== new Date(0).toISOString()
      ? importDateFrom
      : ''
);

export const getImportDateUntilValidation = createSelector(
  getBulkHistoryState,
  ({ importDateUntil }) =>
    importDateUntil?.toISOString() !== new Date(0).toISOString()
      ? importDateUntil
      : ''
);
